// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getSickLeaves: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/sick-leaves', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setSickLeaves', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    getSickLeavesOpen: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/sick-leaves/open', {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments,
            }
        }).then(res => {
            commit('setSickLeaves', res.data.data)
            return res
        }).catch((err) => {
            return err
        });
    },
    get: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/sick-leave/' + payload.sickLeave_id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments
                }
            }
          ).then(res => {
            commit('setSickLeaves', [res.data.data])
            return res
          }).catch((err) => {
            return err
        });
    },
}

export default actions
